import React from "react";
import { capitalizeFirstLetter } from "./../../utils/display";

import { formatBandBalance } from "../../utils/pricingBands";

export default ({ name, sellPercentage, band, submissionMethod, rowIndex }) => (
  <div role="row" className="rates-row" aria-rowindex={rowIndex}>
    <div role="cell" data-label="Brand">
      {name}
    </div>
    <div role="cell" data-label="Payout">{`${sellPercentage}%`}</div>
    <div role="cell" data-label="Card Balance">
      {formatBandBalance(band)}
    </div>
    <div role="cell" data-label="Submission Method">
      {capitalizeFirstLetter(submissionMethod)}{" "}
    </div>
  </div>
);
